/*
  作者：he.zhikai
  时间：2017-10-16
  描述：采编中心-app渠道新闻稿编辑器按钮工厂
*/
'use strict';
angular.module('ueditorForAppBtnServiceModule', []).factory('ueditorForAppBtnService', [
    'ueditorForAppService',
    'modalDialog',
    '$q',
    '$templateRequest',
    'localStorageService',
    'trsUploadAVNewService',
    'ueditorService',
    'editingCenterAppService',
    'editingCenterService',
    function (
        ueditorForAppService,
        modalDialog,
        $q,
        $templateRequest,
        localStorageService,
        trsUploadAVNewService,
        ueditorService,
        editingCenterAppService,
        editingCenterService
    ) {

        /**
         * [insertActivityorAd description]
         * @param   {[object]}  UE    [UE description]
         * @param   {[object]}  ue    [ue description]
         * @param   {[number]}  i     [i description]
         * @param   {[string]}  type  [type description] 活动和广告区别
         * @return  {[type]}          [return description]
         */
        function insertActivityorAd(UE, ue, i, type) {
            var defer = $q.defer();
            var btn = {
                index: i,
                obj: '',
            };
            UE.registerUI(type, function (editor, uiName) {
                editor.registerCommand(uiName, {
                    execCommand: function () {
                        editingCenterAppService
                            .selectActivityOrAdvertising({
                                methodName: type === '插入活动' ? 'getOperateInfo' : 'getAdInfo',
                            })
                            .then((data) => {
                                let theHtml = '';
                                theHtml +=
                                    theHtml = '<img target=' +
                                    data.URL + ' ' +
                                    'style="max-width:1200px;margin:0px auto;display:block;cursor:pointer" feature="advertising" src=' +
                                    data.LISTPICS[0].SRCPICURL + ' ' +
                                    'class="advertising"' +
                                    '></img>';
                                ue.execCommand('insertHtml', theHtml);
                            });
                    },
                });
                btn.obj = new UE.ui.Button({
                    // 按钮的名字
                    name: type,
                    // 提示
                    title: type,
                    // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                    cssRules:
                        type === '插入活动' ? 'background-image: url(lib/ueditor2/themes/default/images/activity.png) !important;background-repeat:no-repeat;background-size: 100% 100%;' : 'background-image: url(lib/ueditor2/themes/default/images/advertising.png) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                    // 点击时执行的命令
                    onclick: function () {
                        editor.execCommand(uiName);
                    },
                });
                defer.resolve(btn);
                return btn.obj;
            });
            return defer.promise;
        }

        /**
         * [insertFinish description]
         * @param   {[object]}  UE    [UE description]
         * @param   {[object]}  ue    [ue description]
         * @param   {[number]}  i     [i description]
         * @param   {[string]}  type  [type description] 
         * @return  {[type]}          [return description]
         */
        function insertFish(UE, ue, i, type) {
            var defer = $q.defer();
            var btn = {
                index: i,
                obj: '',
            };
            UE.registerUI(type, function (editor, uiName) {
                editor.registerCommand(uiName, {
                    execCommand: function () {
                        ue = ue ? ue : UE.getEditor('ueditor');
                        let htmlContent = ue.getContent();
                        let reg = /finish-flag/;
                        if (reg.test(htmlContent)) {
                            return;
                        }
                        var htmlTemplate = ['<p>', '<span class="finish-flag">（完）</span>', '</p>'].join('');
                        htmlContent += htmlTemplate;
                        ue.execCommand('cleardoc');
                        ue.execCommand('insertHtml', htmlContent);
                        ue.fireEvent('contentchange');
                    },
                    // execCommand: function() {},
                });
                btn.obj = new UE.ui.Button({
                    // 按钮的名字
                    name: type,
                    // 提示
                    title: type,
                    // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                    cssRules:
                        type === '插入完结' ? 'background-image: url(lib/ueditor2/themes/default/images/finish.png) !important;background-repeat:no-repeat;background-size: 100% 100%;' : 'background-image: url(lib/ueditor2/themes/default/images/finish.png) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                    // 点击时执行的命令
                    onclick: function () {
                        editor.execCommand(uiName);
                    },
                });
                defer.resolve(btn);
                return btn.obj;
            });
            return defer.promise;
        }

        /**
         * [insertFinish description] 插入音频
         * @param   {[object]}  UE    [UE description]
         * @param   {[object]}  ue    [ue description]
         * @param   {[number]}  i     [i description]
         * @param   {[string]}  type  [type description] 
         * @return  {[type]}          [return description]
         */
        function inserAudio(UE, ue, i, type, scope) {
            var defer = $q.defer();
            var btn = {
                index: i,
                obj: '',
            };
            UE.registerUI(type, function (editor, uiName) {
                editor.registerCommand(uiName, {
                    execCommand: function () {
                        ueditorService.basicUploadAudio(UE, ue);
                    },
                    // execCommand: function() {},
                });
                btn.obj = new UE.ui.Button({
                    // 按钮的名字
                    name: '插入音频',
                    // 提示
                    title: '插入音频',
                    // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                    cssRules:
                        'background-image: url(lib/ueditor2/themes/default/images/editor-for-yinpin.png) !important;background-repeat:no-repeat;background-size: 100% 100%;background-position: 0px 0px !important',
                    // 点击时执行的命令
                    onclick: function () {
                        editor.execCommand(uiName);
                    },
                });
                if (scope.draftType !== 'video') {
                    defer.resolve(btn);
                    return btn.obj;
                } else {
                    defer.reject();
                }
                // defer.resolve(btn);
                // return btn.obj;
            });
            return defer.promise;
        }
        return {

            /**
             * [pageBreak description] 插入分页
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            pageBreak: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('pagebreak', function (editor, uiName) {
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            // ue.execCommand('insertHtml', '<trs_page_separator pagetitle="" firstpagetitle=""/>');
                            ue.execCommand('insertHtml', '<hr ispageseparator="true"/>');
                            ue.fireEvent('contentchange');
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        name: 'pagebreak',
                        title: '插入分页',
                        cssRules: 'background-position: -460px -40px;',
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.type === 'website') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertLead description] 插入导语
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertLead: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('插入导语', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入导语', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            $templateRequest('./components/util/ueditor/service/insertLead/lead_tpl.html').then(function (template) {
                                ue.execCommand('insertHtml', template);
                                ue.fireEvent('contentchange');
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入导语',
                        // 提示
                        title: '插入导语',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/insertLead.png) !important;background-repeat:no-repeat',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.newFeatures['插入导语']) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [preview description] 预览
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            preview: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('预览', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            // alert("预览");
                            // ueditorForAppService.preview();
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '预览',
                        // 提示
                        title: '预览',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/preview.png) !important;background-repeat:no-repeat',
                        // 点击时执行的命令
                        onclick: function () {
                            ueditorForAppService.preview(scope.save);
                            // editor.execCommand(uiName);
                        },
                    });
                    if (scope.newFeatures['预览'] && (scope.authority['app.daibian.yulan'] || scope.authority['app.daishen.yulan'])) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertComponent description] 插入组件
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertComponent: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('插入组件', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            // alert("插入组件");
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入组件', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            ueditorForAppService.insertComponent(ue);
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入组件',
                        // 提示
                        title: '插入组件',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/insertComponent.png) !important;background-repeat:no-repeat',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.newFeatures['插入组件']) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [recoverLocalVersion description] 恢复本地版本
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            recoverLocalVersion: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('button', function (editor, uiName) {
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            var flag = false;
                            var content = '';
                            var storage = localStorageService.get('ueLocalVersion');
                            if (storage !== null) {
                                for (var i = 0; i < storage.length; i++) {
                                    if (storage[i][scope.type + '_ID'] === scope.list.METADATAID + '') {
                                        content = storage[i].CONTENT;
                                        flag = true;
                                        break;
                                    }
                                }
                            }
                            if (flag) {
                                modalDialog.alertType('确定恢复未保存的稿件正文至编辑区？', '', 'ask', true, function () {
                                    ue.setContent(content);
                                });
                            } else {
                                modalDialog.alertType('没有未保存的稿件正文', '', 'info', false);
                            }
                        },
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '恢复本地版本',
                        // 提示
                        title: '恢复本地版本',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        // cssRules: 'background-position: -559px -39px;',
                        // 点击时执行的命令
                        onclick: function() {
                            // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        },
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;
            },

            /**
             * [insertVideo description]插入视频
             *
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             *
             * @return  {[type]}         [return description]
             */
            insertVideo: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                // 插入视频开始 ---start
                UE.registerUI('button2', function (editor, uiName) {
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            trsUploadAVNewService.openVideoModal()
                                .then(function (data) {
                                    for (var i = 0; i < data.html.length; i++) {
                                        if (data.html[i].videoHtml) {
                                            var dom = document.createElement('div');
                                            dom.innerHTML = data.html[i].videoHtml;
                                            ue = ue ? ue : UE.getEditor('ueditor');
                                            ue.execCommand('inserthtml', dom.innerHTML);
                                            ue.focus();
                                            setTimeout(function () {
                                                ue.fireEvent('contentChange');
                                            }, 800);
                                        }
                                    }
                                });
                        },
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入视频',
                        // 提示
                        title: '插入视频',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        // cssRules: 'background-position: -321px -140px;',
                        // 点击时执行的命令
                        onclick: function() {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
                // 插入视频结束 ---end
            },

            /**
             * [insertImage description] 插入图片
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertImage: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('插入图片', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () { },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入图片',
                        // 提示
                        title: '插入图片',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        // cssRules: 'autoformat',
                        // 点击时执行的命令
                        onclick: function() {
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入图片', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            ueditorService.basicUploadPic('picture').then(function (data) {
                                ueditorService.insertImages(data).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                            // ueditorService.basicUploadPic('picture').then(function (data) {
                            //     var dom = document.createElement('div');
                            //     dom.innerHTML = data;
                            //     var index = 0;
                            //     var $imgs = $(dom).find('img');
                            //     $imgs.each(function () {
                            //         this.onload = function () {
                            //             if (this.width > UE.getEditor('ueditor').options.initialFrameWidth - 40) {
                            //                 // 图片大于当前编辑器最大宽度时候处理 少40px是为了对称
                            //                 $(this).attr('width', UE.getEditor('ueditor').options.initialFrameWidth - 40);
                            //             }
                            //             index++;
                            //             if (index === $imgs.length) {
                            //                 ue = ue ? ue : UE.getEditor('ueditor');
                            //                 ue.execCommand('inserthtml', dom.innerHTML);
                            //                 ue.fireEvent('contentChange');
                            //             }
                            //         };
                            //     });
                            // }); // 此处按照要求改为与其他渠道一样的方式
                        },
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;

                /**
                 * [loadImage description] 图片加载成功后撑开编辑页
                 * @return {[type]} [description]
                 */
                function loadImage() {
                    var $imgs = $(ue.body).find('.loadImg');
                    $imgs.each(function () {
                        var self = this;
                        this.onload = function () {
                            ue.fireEvent('contentChange');
                            $(self).removeClass('loadImg');
                        };
                    });
                }
            },

            /**
             * [insertCloudPlateFlag description] 云平台组件
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertCloudPlateFlag: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                var insertCloudPlateFlag = false;
                UE.registerUI('云平台组件', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            ueditorForAppService.cloudPlate();
                            scope.$on('insertCloudPlate', function (event, value) {
                                if (insertCloudPlateFlag) {
                                    return;
                                }
                                insertCloudPlateFlag = true;
                                setTimeout(function () {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.execCommand('insertHtml', value);
                                    ue.fireEvent('contentchange');
                                    insertCloudPlateFlag = false;
                                }, 500);
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '云平台组件',
                        // 提示
                        title: '云平台组件',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/cloudPlate.png) !important;background-repeat:no-repeat',
                        // 点击时执行的命令
                        onclick: function () {
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入云平台组件', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.newFeatures['云平台组件']) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertLeader description] 插入官员
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertLeader(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('插入官员', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            ueditorForAppService.insertLeader(scope.siteId).then((resp) => {
                                let theHtml = '';
                                resp.forEach((data, index) => {
                                    let $a = $(document.createElement('a'));
                                    $a.attr({
                                        class: 'wgLink',
                                        onclick: 'return false',
                                        contenteditable: false,
                                        href: data.url,
                                        id: data.id,
                                        target: '_blank',
                                        position: data.position,
                                    });
                                    $a.text(data.name);
                                    theHtml += $a[0].outerHTML;
                                });

                                ue.execCommand('insertHtml', theHtml);
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入官员',
                        // 提示
                        title: '插入官员',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/insertLeader.png) !important;background-repeat:no-repeat;background-position: 2px 2px;',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.newFeatures['插入官员']) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertTopic description] 插入话题
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertTopic(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                var insertCloudPlateFlag = false;
                UE.registerUI('插入话题', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            ueditorForAppService.insertTopic(scope.siteId).then((resp) => {
                                let theHtml = `<trs_docht contenteditable="false" metadataid="${resp.METADATAID}"><a>#${resp.LISTTITLE}#</a></trs_docht>`;
                                ue.execCommand('insertHtml', theHtml);
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入话题',
                        // 提示
                        title: '插入话题',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/insertTopic.png) !important;background-repeat:no-repeat;background-position: 2px 2px;',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.newFeatures['插入话题']) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertInternalLink description] 批量水印
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            multiImgsWaterLink: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('批量水印', function (editor, uiName) {
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            var reg = /[^\\\/]*[\\\/]+/g;
                            var dom = $(ue.body);
                            var imgs = $(dom).find('img');
                            var sendList = [];
                            var check = 'FileName';
                            for (var i = 0; i < imgs.length; i++) {
                                if ($(imgs[i]).attr('videoid')) {
                                    continue;
                                }
                                var checkList = imgs[i].src.split(/[? = & \s+]/);
                                var index = checkList.indexOf(check);
                                let tmp = {
                                    APPFILE: index === -1 ? imgs[i].src.replace(reg, '') : checkList[index + 1], 
                                    PERPICURL: imgs[i].src,
                                };
                                sendList.push(tmp);
                            }
                            ueditorService.multiImgsWaterLink(sendList).then(function (result) {
                                for (var i = 0; i < imgs.length; i++) {
                                    if ($(imgs[i]).attr('videoid')) {
                                        imgs[i].src = $(imgs[i]).attr('_src');
                                        continue;
                                    }
                                    var checkList = imgs[i].src.split(/[? = & \s+]/);
                                    var index = checkList.indexOf(check);
                                    var find = '';
                                    if (index !== -1) {
                                        find = checkList[index + 1];
                                    } else {
                                        find = imgs[i].src.replace(reg, '');
                                    }
                                    if (result.LIST[find]) {
                                        imgs[i].src = result.LIST[find] && result.LIST[find].FILEURL;
                                    }
                                }
                                ue.setContent($(ue.body).html());
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '批量水印',
                        // 提示
                        title: '批量水印',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/shuiyin.png) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.type === 'website' || scope.type === 'app') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertActivity description] 插入活动
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertActivity: function (UE, scope, ue, i) {
                return insertActivityorAd(UE, ue, i, '插入活动');
            },


            /**
             * [insertAdvertising description]插入广告
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertAdvertising: function (UE, scope, ue, i) {
                return insertActivityorAd(UE, ue, i, '插入广告');
            },

            /**
             * [UE description] 一键排版
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            aKeyComposing: function (UE, scope, ue, i, media) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                    // 插入视频开始 ---start
                UE.registerUI('一键排版', function (editor, uiName) {
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                        },
                    });
    
                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '一键排版',
                        // 提示
                        title: '一键排版',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/pai.svg) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                        // 点击时执行的命令
                        onclick: function() {
                            ueditorService.autotypesetFun(ue, media);
                        },
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;
                // 插入视频结束 ---end
            },

            /**
             * [insertEcharts description] 插入echart
             * @param  {[type]} UE    [description]
             * @param  {[type]} scope [description]
             * @param  {[type]} ue    [description]
             * @param  {[type]} i     [description]
             * @return {[type]}       [description]
             */
            insertEcharts: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('插入图表', function(editor, uiName) { // 插入图表功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() { }
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入图表',
                        // 提示
                        title: '插入图表',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/insertEcharts.png) !important;background-repeat:no-repeat;background-size: 20px 20px;',
                        // 点击时执行的命令
                        onclick: function() {
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入图表', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            ueditorForAppService.insertEcharts().then(function(res) {
                                try {
                                    ue.execCommand('insertHtml', res);
                                } catch (e) {
                                    // console.log(e);
                                } finally {
                                    // loadImage();
                                }
                            });
                        }
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;

            //     // /**
            //     //  * [loadImage description] 图片加载成功后撑开编辑页
            //     //  * @return {[type]} [description]
            //     //  */
            //     // function loadImage() {
            //     //     var $imgs = $(ue.body).find('.loadImg');
            //     //     $imgs.each(function() {
            //     //         var self = this;
            //     //         this.onload = function() {
            //     //             ue.fireEvent('contentChange');
            //     //             $(self).removeClass('loadImg');
            //     //         };
            //     //     });
            //     // }
            },

            /**
             * [insertActivity description] 插入完结
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertFinish: function (UE, scope, ue, i) {
                return insertFish(UE, ue, i, '插入完结');
            },

            /**
             * [insertActivity description] 插入音频
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertAudio: function (UE, scope, ue, i) {
                return inserAudio(UE, ue, i, '插入音频', scope);
            },

            /**
             * [insertAttachment description] 插入附件
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertAttachment: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                let mediaName = editingCenterService.getMediaName(editingCenterService.getEditPageMediaType());
                let docType = editingCenterService.getDocType(editingCenterService.getDocTypeId);
                if (docType !== '新闻' || (mediaName !== 'I我' && mediaName !== '客户端')) {
                    defer.reject();
                    return defer.promise;
                }
                UE.registerUI('插入附件', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () { },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: 'attachment',
                        // 提示
                        title: '插入附件',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'attachment',
                        // 点击时执行的命令
                        onclick: function() {
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入附件', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            ueditorService.uploadAttachment().then(function (data) {
                                ueditorService.insertAttachment(data).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                        },
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;

            },
        };
    },
]);
